import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import { dateFormatter } from '../../../../../utils';

function getMonthYear(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: '2-digit' };
  return date.toLocaleDateString('en-GB', options);
}

const DETAIL_HEADER = [
  {
    header: 'Product',
    accessor: (row) => row?.product?.name
  }
];
const STOCK_STATUS_HEADER = [
  {
    header: 'Batch No.',
    accessor: ''
  },
  {
    header: 'Exp Date',
    accessor: ''
  },
  {
    header: 'Stock',
    accessor: ''
  }
];

const PRODUCT_DETAIL_HEADER = [
  {
    header: 'Batch No.',
    accessor: (row) => row?.batch_no
  },
  {
    header: 'Exp. Date',
    accessor: (row) => getMonthYear(row?.exp_date)
  },
  {
    header: 'Bill Qty',
    accessor: (row) => row?.bill_qty
  },
  {
    header: 'Packing',
    accessor: (row) => row?.packing
  },
  {
    header: 'Current Stock',
    accessor: (row) => row?.total_qty
  }
];

export const StorePurchaseReturnAddDetails = ({
  onClose,
  chargeType = 'opd_charges',
  doctorID,
  onAdd,
  supplier,
  productDropdown
}) => {
  const [input, setInput] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [grn, setGrn] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productDetails, setProductDetails] = useState([]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        batch: Yup.string().required('Please Enter Batch No')
      })
    ),
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    console.log('HELLO FORMVALUES', formValues);
    formValues.gst = +formValues.gst;
    formValues.dis_percent = +formValues.dis_percent;
    const productId = productDropdown.find(({ name }) => name === formValues.product)?._id || '';
    const transformedValues = {
      ...formValues,
      product: productId
    };
    console.log('HELLLO TRANSFORMED VALUES', transformedValues);
    onAdd(transformedValues);
    reset();
  };

  const ReturnQty = watch('rqty');
  const rate = watch('rate');
  const billQty = watch('bill_qty');
  const freeQty = watch('free_qty');
  const discPerWatch = watch('dis_percent');
  const discAmtWatch = watch('dis_amt');
  const gstPerWatch = watch('gst');
  const taxableWatch = watch('taxable');
  const mrp = watch('mrp');

  useEffect(() => {
    const totalAmount = rate * ReturnQty;
    const RecQty = Number(freeQty) + Number(billQty);
    setValue('amount', totalAmount || 0);
    setValue('rec_qty', RecQty || 0);
    setValue('sal_rate', mrp || 0);
  }, [billQty, rate, discPerWatch, gstPerWatch, freeQty, ReturnQty, setValue]);
  useEffect(() => {
    const totalAmount = rate * ReturnQty;
    if (totalAmount && rate && discPerWatch !== undefined) {
      const newDiscAmt = parseFloat(((discPerWatch / 100) * totalAmount).toFixed(2));
      setValue('dis_amt', newDiscAmt);
    }
  }, [rate, ReturnQty, discPerWatch, setValue]);

  useEffect(() => {
    const totalAmount = rate * ReturnQty;
    if (totalAmount && !isNaN(totalAmount) && !isNaN(discAmtWatch)) {
      const taxableAmount = totalAmount - discAmtWatch;
      setValue('taxable', taxableAmount);
    } else {
      setValue('taxable', 0);
    }
  }, [rate, ReturnQty, discAmtWatch, setValue]);

  const taxable = watch('taxable');

  useEffect(() => {
    if (taxable && gstPerWatch) {
      const netAmount = taxable + (taxable * gstPerWatch) / 100;
      const sgst = parseFloat(((netAmount * 9) / 100).toFixed(2));
      const cgst = parseFloat(((netAmount * 9) / 100).toFixed(2));
      const total = parseFloat((netAmount + sgst + cgst).toFixed(2));
      setValue('net_amt', parseFloat(netAmount.toFixed(2)));
      setValue('sgst', sgst);
      setValue('cgst', cgst);
      setValue('total', total);
    }
  }, [taxable, gstPerWatch, setValue]);

  const getConsignmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('store-stock-master-adddetail');
    const filteredData = data.filter((item) => item.supplier === supplier && item.cnt.includes('GRN'));
    setGrn(filteredData);
    setSelectedProduct(true);
  }, []);

  useEffect(() => {
    getConsignmentDropdown();
  }, [getConsignmentDropdown]);

  const handleRowClick = (row) => {
    const filteredProducts = grn.filter((product) => product.product === row.product);
    if (filteredProducts.length > 0) {
      setProductDetails(filteredProducts);
      console.log('HELLO PRODUCT DETAILS', filteredProducts);
    }
  };

  const handleRowClickProductDetail = (row) => {
    const isProduct = productDetails.some((product) => product._id === row._id);
    if (isProduct) {
      setValue('rate', row[chargeType] || 0);
    }
    setValue('batch', row?.batch_no);
    setValue('product', row?.product?.name);
    setValue('exp_date', dateFormatter(row?.exp_date));
    setValue('cnt_no', row?.cnt_no);
    setValue('bill_qty', row?.bill_qty);
    setValue('rate', row?.rate);
    setValue('gst', row?.gst);
    setValue('cnt_no', row?.cnt);
    setValue('stock', row?.total_qty);
    setValue('mrp', row?.mrp);
    setValue('unit', row?.unit);
    setValue('dis_percent', row?.dis_percent);
    setValue('dis_amt', row?.dis_amt);
    setValue('fqty', row?.free_qty);
    setValue('conversion', row?.conversion);
    setValue('packing', row?.packing);
  };

  const filterUniqueProducts = (consignmentData) => {
    const filteredData = consignmentData.reduce((acc, current) => {
      const x = acc.find((item) => item.product === current.product);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredData;
  };
  const billqtywatch = watch('bill_qty');
  const rqty = watch('rqty');
  const packing = watch('packing');
  const conversion = watch('conversion');
  const stock = watch('stock');

  const isRqtyInvalid = rqty > billqtywatch;
  const ValidRqty = rqty * packing * conversion >= stock;
  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Selected Product</Typography>
                <SelectTag formControlSX={{ flex: 1 }} name="selected_product" placeholder="Select Product" disabled />
                <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                <SelectTag formControlSX={{ flex: 0.4 }} disabled name="unit" />
              </Stack>
              <Grid item xs={12}>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                  <Table
                    containerSX={{ flex: 0.7, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={productDetails || []}
                    columns={PRODUCT_DETAIL_HEADER}
                    onRowClick={handleRowClickProductDetail}
                    size="small"
                  />
                  <Table
                    containerSX={{ flex: 0.3, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={filterUniqueProducts(grn || [])}
                    columns={DETAIL_HEADER}
                    size="small"
                    onRowClick={handleRowClick}
                  />
                </Stack>
              </Grid>
              <Grid item xs={8.3}>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Batch </Typography>
                  <TextField sx={{ flex: 0.3 }} name="batch" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Exp. Date</Typography>
                  <TextField sx={{ flex: 0.3 }} name="exp_date" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>CNT No.</Typography>
                  <TextField sx={{ flex: 0.3 }} disabled name="cnt_no" />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                  <TextField sx={{ flex: 0.3 }} disabled name="bill_qty" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Stock</Typography>
                  <TextField sx={{ flex: 0.3 }} name="stock" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>RQty</Typography>
                  <TextField
                    sx={{ flex: 0.3 }}
                    name="rqty"
                    error={isRqtyInvalid || ValidRqty}
                    helperText={
                      isRqtyInvalid
                        ? 'RQty cannot be more than BillQty'
                        : ValidRqty
                          ? 'RQty cannot be more than Stock'
                          : ''
                    }
                  />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>FQty</Typography>
                  <TextField sx={{ flex: 0.3 }} name="fqty" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                  <TextField sx={{ flex: 0.3 }} name="rate" disabled />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                  <TextField sx={{ flex: 0.3 }} disabled name="amount" />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Dis%</Typography>
                  <TextField sx={{ flex: 0.3 }} name="dis_percent" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Disc Amt</Typography>
                  <TextField sx={{ flex: 0.3 }} name="dis_amt" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Packing </Typography>
                  <TextField sx={{ flex: 0.3 }} name="packing" disabled />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Taxable</Typography>
                  <TextField sx={{ flex: 0.3 }} name="taxable" type="taxable" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                  <TextField sx={{ flex: 0.3 }} name="gst" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>SGST</Typography>
                  <TextField sx={{ flex: 0.3 }} name="sgst" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>CGST</Typography>
                  <TextField sx={{ flex: 0.3 }} disabled name="cgst" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>IGST</Typography>
                  <TextField sx={{ flex: 0.3 }} disabled name="igst" />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                  <TextField sx={{ flex: 0.3 }} disabled name="net_amt" />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Product </Typography>
                  <TextField sx={{ flex: 0.3 }} name="product" disabled />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>MRP</Typography>
                  <TextField sx={{ flex: 0.3 }} name="mrp" disabled />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.08, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                  <TextField sx={{ flex: 0.18 }} name="unit" disabled />
                  <Typography sx={{ flex: 0.08, fontWeight: 700, fontSize: '1.4rem' }}>Conversion</Typography>
                  <TextField sx={{ flex: 0.16 }} name="conversion" disabled />
                  <Checkbox sx={{ flex: 0.3 }} name="gst_inclusive" />
                  <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>GST Incl.</Typography>
                </Stack>
              </Grid>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
